import {
  proIPKey,
  TrustPilotKey,
  getTenantId,
  zipCodeKey,
  ip2LocationKey,
  AudioExtension,
  VideoExtension,
  ImageExtension,
  getServiceToken,
  bypassIpAddress,
} from "../utils/general-config";
import { useEffect } from "react";
import axios from "axios";
import {
  getSsoResumeBuildEndPoint,
  getPdfSimpliBaseURL,
  getSignSimpliBaseURL,
  getTrustPilotServiceEndPoint,
  getLegalSimpliBaseURL,
  getWorksimpliEndPoint,
} from "../services/api-constants";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import sha1 from "sha1";
import { availableLanguages } from "../i18nextInit";

import {
  BasePortalCD,
  DASHBOARD_ABTESTID,
  DASHBOARD_ABTESTID_COOKIE,
  DomainName,
  emailTemplateSettingsList,
  EMPTY_GUID,
  FROM_EMAIL_NAME,
  reSkinContainerName,
  supportEmail,
  WELCOME_EMAIL_TEXT,
  WELCOME_EMAIL_TEXT_SECURESIMPLI,
} from "./constants";
import { currentDomain, getInitializationVector } from "../utils/general-config";
import docBuilderApi from "../services/doc-builder-api";
import { DomainEnum, environment } from "../services/enum/environment-enum";
import eventServiceApi from "../services/event-service-api";
import orchestrationServiceApi from "../services/orchestration-service-api";
import userServiceApi from "../services/user-service-api";
import CryptoJS from "crypto-js";
import docEditorServiceApi from "../services/doc-editor-service-api";
import { Portal } from "@headlessui/react";
import { useParams } from "react-router-dom";
import { ROUTE_CONSTANT } from "../routing/route-constants";
import visitorServiceApi from "../services/visitor-service-api";
import { UserGuidABTestConduct } from "../pages/sign-up/actions";

let domain = currentDomain();
const currentEnv = `${process.env.REACT_APP_ENVIRONMENT}`;

export const isAuthorizedAccess = () => {
  return !!readCookie("jwtToken") ? true : false;
};
export const CreateUUID = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
  );
};

export const readCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();
    if (c.indexOf(nameEQ) === 0) {
      const value = c.substring(nameEQ.length);
      if (value === "null" || value === "undefined") return null;
      return value;
    }
  }
  return null;
};

export const generateCookie = (name, value, days, cookieForDomain) => {
  var expires = "";
  var _domain = "";

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else expires = "";

  if (cookieForDomain) {
    _domain = "; domain=" + cookieForDomain;
  }
  document.cookie = name + "=" + value + expires + _domain + "; path=/;";
};

export const createCookie = (name, value, days, domainName) => {
  // NOTE :: Temp check For local host..
  if (window.location.href.indexOf("localhost") > -1) {
    domainName = "";
  } else {
    domainName = "";
  }

  generateCookie(name, value, days, domainName);
};
export const deleteCookie = (name) => {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};
export const deletedomainCookie = (name) => {
  const domains = [".pdfsimpli.com", ".signsimpli.com", ".resumebuild.com", ".legalsimpli.com", ""];
  domains.forEach((domain) => {
    document.cookie = name + "=; domain=" + domain + "; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  });
};
export const concatStringsUsingComma = (s1, s2, s3, s4, s5) => {
  let arr = [s1, s2, s3, s4, s5];
  return arr.filter((x) => !!x && x != "").join(", ");
};

export const concatNotEmptyBy =
  (separator) =>
  (...args) => {
    return args.filter((n) => n).join(separator);
  };

export default CreateUUID;

export const sorterExperience = (a, b) => {
  const year1 = JSON.parse(a.content).endDateYear;
  const year2 = JSON.parse(b.content).endDateYear;
  const month1 = JSON.parse(a.content).endDateMonth;
  const month2 = JSON.parse(b.content).endDateMonth;
  const presently_here1 = JSON.parse(a.content).presently_here;
  const presently_here2 = JSON.parse(b.content).presently_here;
  if (presently_here1) {
    return -1;
  } else if (presently_here2) {
    return 1;
  } else if (year1 !== year2) {
    return year2 - year1;
  } else {
    return month2 - month1;
  }
};

export const sorterEducation = (a, b) => {
  const year1 = JSON.parse(a.content).education_graduation_year;
  const year2 = JSON.parse(b.content).education_graduation_year;
  const month1 = JSON.parse(a.content).education_graduation_month;
  const month2 = JSON.parse(b.content).education_graduation_month;
  const presently_here1 = JSON.parse(a.content).presently_here;
  const presently_here2 = JSON.parse(b.content).presently_here;
  if (presently_here1) {
    return -1;
  } else if (presently_here2) {
    return 1;
  } else if (year1 !== year2) {
    return year2 - year1;
  } else {
    return month2 - month1;
  }
};

export const getIPConfig = async () => {
  let ipAddress = readCookie("ipAddress");
  const ipObject = checkIP(ipAddress);
  let proIpUrl = "https://pro.ip-api.com/json?key=" + proIPKey();
  let ip2LocationUrl = "https://api.ip2location.io/?key=" + ip2LocationKey;
  let country = !!readCookie("country") ? readCookie("country") : "";
  if (!isNullOrEmpty(ipAddress)) {
    proIpUrl = "https://pro.ip-api.com/json/" + ipAddress + "?key=" + proIPKey() + "";
    ip2LocationUrl = "https://api.ip2location.io/?key=" + ip2LocationKey + "&ip=" + ipAddress;
  }
  try {
    let proIpResponse = await axios.get(proIpUrl + "&fields=country,countryCode,status,query,currency,region,zip,city");
    if (
      !!proIpResponse &&
      !!proIpResponse.data &&
      proIpResponse.data.status === "success" &&
      !!proIpResponse.data.zip
    ) {
      createCookieBaseOnProIpAndIp2Response(
        proIpResponse.data.countryCode,
        proIpResponse.data.currency,
        proIpResponse.data.status,
        proIpResponse.data.query,
        proIpResponse.data.region,
        proIpResponse.data.zip,
        proIpResponse.data.city,
        ipAddress,
      );
      await updateVisitorDwhFromCookies();
    } else if (!!country && country?.toLowerCase() === "us" && !proIpResponse?.data?.zip?.trim()) {
      if (ipObject?.isPrivate || ipObject?.isLoopback) {
        console.log("IP is private or loopback");
      } else {
        let ip2Response = await axios.get(ip2LocationUrl);
        if (!!ip2Response) {
          createCookieBaseOnProIpAndIp2Response(
            ip2Response.country_code,
            ip2Response.country.currency.code,
            "fail",
            ip2Response.ip,
            ip2Response.region.code.split("-")[1],
            ip2Response.zip_code,
            ip2Response.city_name,
            ipAddress,
          );
          await updateVisitorDwhFromCookies();
        }
      }
    }
  } catch (error) {
    console.log("proip fail", error);
    if (ipObject?.isPrivate || ipObject?.isLoopback) {
      console.log("IP is private or loopback");
    } else {
      let ip2Response = await axios.get(ip2LocationUrl);
      if (!!ip2Response) {
        createCookieBaseOnProIpAndIp2Response(
          ip2Response.country_code,
          ip2Response.country.currency.code,
          "fail",
          ip2Response.ip,
          ip2Response.region.code.split("-")[1],
          ip2Response.zip_code,
          ip2Response.city_name,
          ipAddress,
        );
        await updateVisitorDwhFromCookies();
      }
    }
  }
};

const updateVisitorDwhFromCookies = async () => {
  const payload = {
    visitId: readCookie("visitGuid"),
    ip: readCookie("ipAddress"),
    country: readCookie("country"),
    city: readCookie("city"),
    region: readCookie("region"),
    zip: readCookie("zip"),
  };

  if (!payload.visitId || !payload.ip) return;

  await visitorServiceApi.UpdateVisitorDwh(payload);
};

const createCookieBaseOnProIpAndIp2Response = (country, currency, ipStatus, query, region, zip, city, ipAddress) => {
  if (isNullOrEmpty(ipAddress)) {
    createCookie("ipAddress", query);
  }
  createCookie("country", country);
  createCookie("currency", currency);
  createCookie("proipstatus", ipStatus);
  createCookie("zip", zip);
  createCookie("region", region);
  createCookie("city", city);
};
export const gotToDashBoardWithLocale = (locale) => {
  let localeval = "";
  if (!!locale) {
    localeval = locale + "/";
  }
  return getSsoResumeBuildEndPoint + localeval;
};

export const goToPdfSimpli = (locale) => {
  return getPdfSimpliBaseURL + (!locale ? "" : "/" + locale);
};
export const goToSignSimpli = (locale) => {
  return getSignSimpliBaseURL + (!locale ? "" : "/" + locale);
};
export const goToLegalSimpli = () => {
  return getLegalSimpliBaseURL;
};
export const getTrustPilotURL = (email, userGuid) => {
  let tpLink = "";
  if (!!email && !!userGuid) {
    let converted = base64_encode(email);
    let encoded = encodeURIComponent(email);
    userGuid = userGuid.replaceAll("-", "");
    let shaString = sha1(TrustPilotKey() + email + userGuid);
    if (!!getTrustPilotServiceEndPoint) {
      tpLink =
        getTrustPilotServiceEndPoint + "?a=" + userGuid + "&b=" + converted + "&c=" + encoded + "&e=" + shaString;
    }
  }
  //console.log("tpLink", tpLink);
  return tpLink;
};
export const changeToValidFileName = (filname) => {
  filname = filname.replace(/["~!@#$%^&*\(\)=`{}\[\]\|\\:;'<>,\/?"\t\r\n]+/g, "");
  var validFileName = filname.replace(/ /g, " ");
  var ext = filname.split(".").pop().toLowerCase();
  if (validFileName.length >= 75) validFileName = filname.substring(0, 69) + "." + ext;
  return validFileName;
};
export const checkValidExtensionForUploadFile = (ext) => {
  //DOC, DOCX, PDF, RTF, TXT or HTML
  var validExt = false;
  var arrExt = ["pdf", "doc", "docx", "jpg", "jpeg", "png", "xls", "xlsx", "tiff", "tif", "ppt", "pptx", "odt"];

  arrExt.forEach((ele) => {
    if (ext == ele) {
      validExt = true;
    }
  });
  return validExt;
};
export const userGuid = () => {
  let userguid = readCookie("userguid");
  if (!!userguid) {
    return userguid.toLocaleLowerCase();
  } else {
    console.log("PLEASE LOGIN !!");
  }
};

export const base64ArrayBuffer = (arrayBuffer) => {
  var base64 = "";
  var encodings = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

  var bytes = new Uint8Array(arrayBuffer);
  var byteLength = bytes.byteLength;
  var byteRemainder = byteLength % 3;
  var mainLength = byteLength - byteRemainder;

  var a, b, c, d;
  var chunk;

  // Main loop deals with bytes in chunks of 3
  for (var i = 0; i < mainLength; i = i + 3) {
    // Combine the three bytes into a single integer
    chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];

    // Use bitmasks to extract 6-bit segments from the triplet
    a = (chunk & 16515072) >> 18; // 16515072 = (2^6 - 1) << 18
    b = (chunk & 258048) >> 12; // 258048   = (2^6 - 1) << 12
    c = (chunk & 4032) >> 6; // 4032     = (2^6 - 1) << 6
    d = chunk & 63; // 63       = 2^6 - 1

    // Convert the raw binary segments to the appropriate ASCII encoding
    base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d];
  }

  // Deal with the remaining bytes and padding
  if (byteRemainder == 1) {
    chunk = bytes[mainLength];

    a = (chunk & 252) >> 2; // 252 = (2^6 - 1) << 2

    // Set the 4 least significant bits to zero
    b = (chunk & 3) << 4; // 3   = 2^2 - 1

    base64 += encodings[a] + encodings[b] + "==";
  } else if (byteRemainder == 2) {
    chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1];

    a = (chunk & 64512) >> 10; // 64512 = (2^6 - 1) << 10
    b = (chunk & 1008) >> 4; // 1008  = (2^6 - 1) << 4

    // Set the 2 least significant bits to zero
    c = (chunk & 15) << 2; // 15    = 2^4 - 1

    base64 += encodings[a] + encodings[b] + encodings[c] + "=";
  }

  return base64;
};
export const generateUinqueIDentifier = () => {
  var d = new Date().getTime();
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = ((d + Math.random() * 16) % 16) | 0;
    d = Math.floor(d / 16);
    return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
};
export const loadScript = (url) => {
  const script = document.createElement("script");
  script.src = url;
  document.head.appendChild(script);
};

export const removeScript = (url) => {
  var scripts = document.getElementsByTagName("script");
  for (let script of scripts) {
    if (script.src === url) {
      script.remove();
      break;
    }
  }
};
export const loadScriptWithKey = (url, id, key) => {
  const script = document.createElement("script");
  script.src = url;
  script.id = id;
  script.setAttribute("data-app-key", key);
  document.head.appendChild(script);
};
export const setLocaleURL = (url, locale) => {
  let verifiedLocale = "en";
  if (!!locale) {
    if (availableLanguages.indexOf(locale) > -1) {
      verifiedLocale = locale;
    }
  }
  return url.replace(":locale", verifiedLocale);
};
export const getLocaleFromPortalSource = () => {
  const portalSource = new URLSearchParams(window.location.search).get("prtlsrc");
  let prtl = "";
  if (!!portalSource) {
    prtl = portalSource;
    if (prtl.length === 6) {
      prtl = prtl.slice(-2);
    }
  }
  return prtl.toLowerCase();
};

export const useGTM = () => {
  useEffect(() => {
    var gtmTagValue = "";
    var currentUrl = window.location.href;
    if (currentUrl.indexOf("signsimpli") > -1) {
      gtmTagValue = "GTM-PC3HZGV";
    } else if (currentUrl.indexOf("pdfsimpli") > -1) {
      gtmTagValue = "GTM-53GR555";
    } else if (currentUrl.indexOf("resumebuild") > -1) {
      gtmTagValue = "GTM-59VL2P9";
    } else if (currentUrl.indexOf("legalsimpli") > -1) {
      gtmTagValue = "GTM-BP5G6XTR";
    } else if (currentUrl.indexOf("worksimpli") > -1) {
      gtmTagValue = "GTM-PBKBLH5M";
    } else {
      gtmTagValue = "GTM-53GR555"; // this is default value we have put will analyze later
    }
    // Define the dataLayer array if it does not exist
    window.dataLayer = window.dataLayer || [];

    // Push the initial GTM event
    window.dataLayer.push({
      event: "gtm.js",
      "gtm.start": new Date().getTime(),
    });

    // Create the GTM script tag
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmTagValue}`;
    document.head.appendChild(script);

    return () => {
      // Clean up the script if the component unmounts
      document.head.removeChild(script);
    };
  }, []);
};

export const useVWO = ({ enabled = false } = {}) => {
  useEffect(() => {
    if (!enabled) return;
    var currentUrl = window.location.href;
    var vwoId = "737970";
    if (currentUrl.indexOf("resumebuild") > -1) {
      vwoId = "740258";
    } else if (currentUrl.indexOf("signsimpli") > -1) {
      vwoId = "741434";
    }
    // let _vwo_code;
    // let settings_timer;
    // Define the dataLayer array if it does not exist
    window._vwo_code =
      window._vwo_code ||
      (function () {
        var account_id = vwoId,
          version = 1.5,
          settings_tolerance = 2000,
          library_tolerance = 2500,
          use_existing_jquery = false,
          is_spa = 1,
          hide_element = "body",
          hide_element_style = "opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important",
          /* DO NOT EDIT BELOW THIS LINE */
          f = false,
          d = document,
          vwoCodeEl = d.querySelector("#vwoCode"),
          code = {
            use_existing_jquery: function () {
              return use_existing_jquery;
            },
            library_tolerance: function () {
              return library_tolerance;
            },
            hide_element_style: function () {
              return "{" + hide_element_style + "}";
            },
            finish: function () {
              if (!f) {
                f = true;
                var e = d.getElementById("_vis_opt_path_hides");
                if (e) e.parentNode.removeChild(e);
              }
            },
            finished: function () {
              return f;
            },
            load: function (e) {
              var t = d.createElement("script");
              t.fetchPriority = "high";
              t.src = e;
              t.type = "text/javascript";
              t.onerror = function () {
                window._vwo_code.finish();
              };
              d.getElementsByTagName("head")[0].appendChild(t);
            },
            getVersion: function () {
              return version;
            },
            getMatchedCookies: function (e) {
              var t = [];
              if (document.cookie) {
                t = document.cookie.match(e) || [];
              }
              return t;
            },
            getCombinationCookie: function () {
              var e = code.getMatchedCookies(/(?:^|;)\s?(_vis_opt_exp_\d+_combi=[^;$]*)/gi);
              e = e.map(function (e) {
                try {
                  var t = decodeURIComponent(e);
                  if (!/_vis_opt_exp_\d+_combi=(?:\d+,?)+\s*$/.test(t)) {
                    return "";
                  }
                  return t;
                } catch (e) {
                  return "";
                }
              });
              var i = [];
              e.forEach(function (e) {
                var t = e.match(/([\d,]+)/g);
                t && i.push(t.join("-"));
              });
              return i.join("|");
            },
            init: function () {
              if (d.URL.indexOf("__vwo_disable__") > -1) return;
              window.settings_timer = setTimeout(function () {
                window._vwo_code.finish();
              }, settings_tolerance);
              var e = d.createElement("style"),
                t = hide_element ? hide_element + "{" + hide_element_style + "}" : "",
                i = d.getElementsByTagName("head")[0];
              e.setAttribute("id", "_vis_opt_path_hides");
              vwoCodeEl && e.setAttribute("nonce", vwoCodeEl.nonce);
              e.setAttribute("type", "text/css");
              if (e.styleSheet) e.styleSheet.cssText = t;
              else e.appendChild(d.createTextNode(t));
              i.appendChild(e);
              var n = this.getCombinationCookie();
              this.load(
                "https://dev.visualwebsiteoptimizer.com/j.php?a=" +
                  account_id +
                  "&u=" +
                  encodeURIComponent(d.URL) +
                  "&f=" +
                  +is_spa +
                  "&vn=" +
                  version +
                  (n ? "&c=" + n : ""),
              );
              return window.settings_timer;
            },
          };
        window._vwo_settings_timer = code.init();
        return code;
      })();

    return () => {
      if (window._vwo_code && window._vwo_code.finished && !window._vwo_code.finished()) {
        window._vwo_code.finish();
      }
    };
  }, [enabled]);
};

export const useTitle = () => {
  let title = "";
  const currentUrl = window.location.href;
  if (currentUrl.indexOf("signsimpli") > -1) {
    title = "Sign Simpli";
  } else if (currentUrl.indexOf("pdfsimpli") > -1) {
    title = "PDF Simpli";
  } else if (currentUrl.indexOf("resumebuild") > -1) {
    title = "Resume Build";
  } else if (currentUrl.indexOf("legalsimpli") > -1) {
    title = "Legal Simpli";
  } else {
    title = "PDF Simpli";
  }
  return title;
};
export const freshChatTitle = (title) => {
  var script = document.createElement("script");

  script.setAttribute("type", "text/javascript");
  script.setAttribute("src", "//in.fw-cdn.com/31678841/852408.js");
  script.setAttribute("chat", "true");

  document.head.appendChild(script);

  var chat_locale = window.location.href;
  if (chat_locale.indexOf("/es") > -1) {
    chat_locale = "es";
  } else if (chat_locale.indexOf("/it") > -1) {
    chat_locale = "it";
  } else if (chat_locale.indexOf("/fr") > -1) {
    chat_locale = "fr";
  } else if (chat_locale.indexOf("/pt") > -1) {
    chat_locale = "pt";
  } else {
    chat_locale = "en";
  }
  window.fcWidgetMessengerConfig = {
    locale: chat_locale,
  };
};

export const checkEmpty = (value) => {
  return value === null || value === "" || value === undefined;
};

export const updateActions = (dispatch, t, keyName, item) => {
  switch (keyName) {
    default:
      break;
  }
};

export const focusValidateField = (value) => {
  const element = document.getElementById(value);
  if (element) {
    element.focus();
    element.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "start",
    });
  }
};

export const findParaName = (paragraphName, characters) => {
  let data = "";
  characters.length > 0 &&
    characters.forEach((item) => {
      if (item.paraName === paragraphName) {
        data = item.paraContents;
      }
    });
  return data;
};
export const findSquareBrackets = (str) => {
  let findSqareBrakets = [];
  for (let i = 0, j = 0; ; ) {
    i = str.indexOf("[", i);
    if (i !== -1) {
      i = i + 1;
      j = str.indexOf("]", i);
      if (j !== -1) {
        findSqareBrakets.push(str.substring(i, j));
        i = j + 1;
        continue;
      }
    }
    break;
  }
  return findSqareBrakets;
};

export const updateUploadDocCookie = (name, value) => {
  var expires = "";
  var _domain = "";
  var expireTime = readCookie("uploadexpiretime");
  expires = "; expires=" + expireTime;
  document.cookie = name + "=" + value + expires + _domain + "; path=/;";
};

export const setIPConfig = (param, defaultValue) => {
  if (localStorage.getItem("ipconfig") !== null) {
    let ipConfigData = JSON.parse(localStorage.getItem("ipconfig"));
    return ipConfigData[param];
  } else {
    return defaultValue;
  }
};
export const getZipCodebase = async (value) => {
  const apiUrl = `https://app.zipcodebase.com/api/v1/search?apikey=${zipCodeKey}&codes=${value}&country=US`;
  let result = await axios.get(apiUrl);
  if (result.status === 200) {
    return result?.data?.results[value];
  } else {
    console.log("Error in retrieving getZipCodebase status " + result.status);
    return "";
  }
};
export const fetchHTML = async (url, setHtmlContentUrl) => {
  try {
    const response = await fetch(url);
    const html = await response.text();
    setHtmlContentUrl(html);
  } catch (error) {
    console.error("Error fetching HTML:", error);
  }
};
export const getEventPostData = (email, portal, score, userGuid) => {
  const postData = {
    userGuid: userGuid,
    emailAddress: email,
    ipAddress: readCookie("ipAddress"),
    visitorId: readCookie("visitorGuid"),
    visitId: readCookie("visitGuid"),
    portalCD: portal,
    gScore: score,
  };
  return postData;
};
export const isNullOrEmpty = (value) => {
  return value === undefined || value === null || value.trim().length === 0 ? true : false;
};
export const mailTo = () => {
  let mailTo = "";

  mailTo = "mailto:" + getSupportEmail();
  return mailTo;
};

export const getSupportEmail = () => {
  if (domain.toLowerCase() === DomainName.SIGNSIMPLI) {
    return supportEmail.SIGNSIMPLI;
  } else if (domain.toLowerCase() === DomainName.RESUMEBUILD) {
    return supportEmail.RESUMEBUILD;
  } else if (domain.toLowerCase() === DomainName.LEGALSIMPLI) {
    return supportEmail.LEGALSIMPLI;
  } else {
    return supportEmail.PDFSIMPLI;
  }
};

export const isAllAddressCookiePresent = () => {
  const requiredCookies = ["ipAddress", "currency", "zip", "city", "region", "country"];
  const hasBypassIP = bypassIpAddress().includes(readCookie("ipAddress"));
  if (hasBypassIP) {
    deleteCookie("ipAddress");
  }
  // Check if all required cookies are present and non-empty
  const hasAllCookies = requiredCookies.every((cookie) => Boolean(readCookie(cookie)));
  // Special case: If country is "US", ensure "zip" is also present
  const isUS = readCookie("country")?.toLowerCase() === "us";
  const result = hasAllCookies && (!isUS || Boolean(readCookie("zip"))) && !hasBypassIP;
  return result;
};
export const base64decode = (value) => {
  return base64_decode(value);
};
export const currentPortalCD = (locale, subdomain) => {
  let path = window.location.host;
  let portal = BasePortalCD.PS;
  if (path.indexOf("pdfsimpli") > -1 || path.indexOf("localhost") > -1) {
    portal = BasePortalCD.PS;
    if (readCookie("vs_prtlSrc")?.indexOf("PSSC") > -1) {
      portal = BasePortalCD.PSSC;
    } else if (readCookie("vs_prtlSrc")?.indexOf("PSRB") > -1) {
      portal = BasePortalCD.PSRB;
    }
  } else if (path.indexOf("signsimpli") > -1) {
    portal = BasePortalCD.SS;
  } else if (path.indexOf("resumebuild") > -1) {
    portal = BasePortalCD.WSRB;
  } else if (path.indexOf("legalsimpli") > -1) {
    portal = BasePortalCD.LSEN;
  } else if (path.indexOf("worksimpli") > -1) {
    portal = BasePortalCD.WKSM;
  }
  if (!!locale && locale !== "en") portal = portal + locale.toUpperCase();
  return portal;
};

export const isUserLoggedIn = () => {
  let isLoggedIn = false;
  if (!!readCookie("jwtToken")) {
    isLoggedIn = true;
  }
  return isLoggedIn;
};
export const getZipCityStateBasedOnIP = async (ipAddress) => {
  var lstAddress = [];
  // const res = await axios.get(
  //   "https://pro.ip-api.com/json/" +̣
  //     ipAddress +
  //     "?key=" +
  //     proIPKey() +
  //     "&fields=country,countryCode,status,query,currency,region,zip,city"
  // );
  lstAddress.push(readCookie("city"));
  lstAddress.push(readCookie("region"));
  lstAddress.push(readCookie("country"));
  lstAddress.push(readCookie("zip"));
  lstAddress.push(readCookie("ipAddress"));
  return lstAddress;
};

export const UserDocMapping = (docId, userGuid) => {
  return docBuilderApi
    .updateUserDocMapping(docId, userGuid)
    .then((response) => {
      return true;
    })
    .catch((error) => {
      console.log("Error");
      return false;
    });
};

export const getPortalCD = (locale) => {
  const queryParams = new URLSearchParams(window.location.search);
  const convertTo = queryParams.has("to") ? queryParams.get("to") : "";
  let isPdfWzd = convertTo === "pdfwzd";
  let isWzd = convertTo === "wzd";
  if (isPdfWzd || isWzd) {
    return "PSFW";
  } else {
    const prtlSrc = readCookie("vs_prtlSrc");
    let portal = !!prtlSrc ? prtlSrc : currentPortalCD(locale);
    return portal;
  }
};

export const getWelcomeEmailTemplateId = (locale = "en") => {
  locale = locale ? locale.replace(/\//g, "") : "en";

  const matchingTemplate = emailTemplateSettingsList.find(
    (template) => template.Locale.toLowerCase() === locale.toLowerCase(),
  );

  return matchingTemplate
    ? matchingTemplate.WelcomeEmailTemplateId
    : emailTemplateSettingsList[0].WelcomeEmailTemplateId;
};

export const getEmailTemplate = (locale = "en", portal) => {
  locale = locale ? locale.replace(/\//g, "") : "en";

  let matchingTemplate;

  if (portal === DomainName.SECURESIMPLI) {
    matchingTemplate = emailTemplateSettingsList.find(
      (template) =>
        template.TemplateName.toLowerCase().includes("securesimpli") &&
        template.Locale.toLowerCase() === locale.toLowerCase(),
    );
  } else {
    matchingTemplate = emailTemplateSettingsList.find(
      (template) =>
        template.portal.toLowerCase() === portal.toLowerCase() &&
        template.Locale.toLowerCase() === locale.toLowerCase(),
    );
  }

  return matchingTemplate ? matchingTemplate : emailTemplateSettingsList[0];
};

export const sendWelcomeEmail = async (userGuid, locale, processFromSocial) => {
  let localeval = "";

  if (!!locale && locale !== "") {
    localeval = "/" + locale;
  }
  const domain = currentDomain();
  let portal = ""; //currentDomain() === DomainEnum.SIGNSIMPLI ? "SignSimpli" : "PDFSimpli";
  if (currentDomain() === DomainEnum.SIGNSIMPLI) {
    portal = "SignSimpli";
  } else if (currentDomain() === DomainEnum.PDFSIMPLI) {
    portal = "PDFSimpli";
    if (readCookie("vs_prtlSrc") === "PSSC") {
      portal = DomainName.SECURESIMPLI;
    }
  } else if (currentDomain() === DomainEnum.WORKSIMPLI) {
    portal = "WorkSimpli";
  }
  const user = await userServiceApi.getUserByUserGuid(userGuid);
  const portalCD = currentPortalCD();
  // const dynamicPhoneNumber = await orchestrationServiceApi.getDynamicPhoneNumber(user.currencyCD, portalCD);
  //const mailProcessor = "sendgrid";
  // const rsknABTest = readCookie("rsknABTest");
  // const isReskin = rsknABTest === "true";
  let emailMeta = getEmailMeta(user, portalCD, localeval, processFromSocial, portal);
  let templateObject = getEmailTemplate(locale, portal);

  const emaiDelivery = {
    userGuid: userGuid,
    templateId: templateObject.WelcomeEmailTemplateId,
    //emailProvider: mailProcessor,
    emailMetaData: emailMeta,
    envelopeId: EMPTY_GUID,
    isAttachment: false,
    tenantId: getTenantId(),
  };
  const eventType = portalCD.indexOf("WKSM") > -1 || portalCD === "PSSC" ? "PS" : portalCD;
  await eventServiceApi.postDataToEventService(emaiDelivery, eventType, "Email", "emailengine");
};

const getEmailMeta = (user, portalCD, localeval, processFromSocial, portal) => {
  const emailMeta = {};

  let isvalidcheck = true;
  if (!!processFromSocial || processFromSocial) {
    isvalidcheck = false;
  }

  emailMeta.accountid = user?.accountId;
  emailMeta.FirstName = user?.firstName;
  // emailMeta.PhoneNumber = dynamicPhoneNumber.data;
  emailMeta.PortalCD = portalCD;
  emailMeta.currenturl =
    getPortalConfig()
      .portalBaseUrl.replace(/^https:\/\//, "")
      .replace(/\/$/, "") +
    "/app" +
    localeval +
    "/account/signin";
  emailMeta.toemail = user?.email;
  emailMeta.sendername = FROM_EMAIL_NAME.replace("##", getPortalConfig().senderNamePrefix);
  emailMeta.emailsubject =
    portal === DomainName.SECURESIMPLI
      ? WELCOME_EMAIL_TEXT_SECURESIMPLI
      : WELCOME_EMAIL_TEXT.replace("##", getPortalConfig().portal);
  emailMeta.disablebcc = "true";
  emailMeta.isvalidcheck = isvalidcheck.toString();
  //emailMeta.container = isReskin ? reSkinContainerName.CONTAINER : "";
  emailMeta.portal = portal;
  emailMeta.useremail = user?.email;
  if (portal === DomainName.SECURESIMPLI) {
    emailMeta.magic_link = createMagicLink("wbp", localeval);
  }
  emailMeta.redirection_link = createRedirectionLink(getPortalConfig().portalBaseUrl, localeval);
  return emailMeta;
};

// export const welcomeEmail = async (userGuid, locale) => {
//   let localeval = "";
//   if (!!locale && locale !== "") {
//     localeval = "/" + locale;
//   }
//   const user = await userServiceApi.getUserByUserGuid(userGuid);
//   const portalCD = getPortalCD();
//   const dynamicPhoneNumber = await orchestrationServiceApi.getDynamicPhoneNumber(user.currencyCD, portalCD);
//   const mailProcessor = "sendgrid";

//   const emailMeta = {};
//   emailMeta.accountid = user.accountId;
//   emailMeta.FirstName = user.firstName;
//   emailMeta.PhoneNumber = dynamicPhoneNumber.data;
//   emailMeta.PortalCD = portalCD;
//   emailMeta.currenturl = getPdfSimpliBaseURL.replace(/^https:\/\//, "") + "app" + localeval + "/account/signin";
//   emailMeta.toemail = user.email;
//   emailMeta.sendername = FROM_EMAIL_NAME;
//   emailMeta.emailsubject = WELCOME_EMAIL_TEXT.replace("##", "PDFSimpli");
//   emailMeta.disablebcc = "true";
//   emailMeta.isvalidcheck = "true";

//   const emaiDelivery = {
//     userGuid: userGuid,
//     templateId: getWelcomeEmailTemplateId(locale),
//     emailProvider: mailProcessor,
//     emailMetaData: emailMeta,
//     envelopeId: EMPTY_GUID,
//     isAttachment: false,
//     tenantId: getTenantId(),
//   };
//   await eventServiceApi.postDataToEventService(emaiDelivery, "PS", "Email", "emailengine");
// };

export const DecryptedString = (encryptedText, key) => {
  const iv = getInitializationVector();
  const bytes = CryptoJS.AES.decrypt(encryptedText, CryptoJS.enc.Utf8.parse(key), {
    iv: CryptoJS.enc.Utf8.parse(iv),
  });
  const decrypted = bytes.toString(CryptoJS.enc.Utf8);
  console.log(decrypted);
  return decrypted;
};

export const PerquisiteBountyEnable = (chiperText, userGuid) => {
  if (!!chiperText) {
    const decryptVal = DecryptedString(chiperText, userGuid.replaceAll("-", ""));
    return decryptVal?.toLowerCase() === "true" ? true : false;
  } else {
    return false;
  }
};
export const getJWTServiceToken = () => {
  const jwtToken = {
    QA: "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjIwLCJraWQiOiI0NGUwZmY2MzgwY2E0YzhkOWFlNzBjMjExMjc5NGFiNyJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9zaWQiOiIwMDAwMDAwMC0wMDAwLTAwMDAtMDAwMC0wMDAwMDAwMDAwMDAiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL2dyb3Vwc2lkIjoiN2ZjOWY0MjUtMTQ2My00YThlLTg1NTYtNmM2YjM0Y2ZjZmY2Iiwic2NvcGUiOiJmdWxsYWNjZXNzIiwidGVuYW50X2dyb3VwX2lkIjoiNTgwYzhiNWEtZGI4My00ODM0LTE0ZWYtMDhkOTUwMWU3MzVkIiwibmJmIjoxNzI4NTUzMDk2LCJleHAiOjIwNDQxMjkwOTYsImlzcyI6IkxlZ2FsU2ltcGxpIiwiYXVkIjoiUERGU2ltcGxpIn0.KameEF9JU4__i_tmeiJQprFIpc0gGoNrXE4ti-ZqCqAhT2UflZL6NCz-herJ3pZfRTGUfsvR8n5-kPZeALbv1F_JY3sjEN4k5m-D2r4L2XjnpS7nNTznc2K5SImmounTp5F3kscXTz-qdQMInE3FjDD6U0Dbl8VPCFQR9e1XzS3_cegwTa3-tqcM7bJAsGkC17EQMec-loQiv55FISd_L8_Wq2dt3QbCnEYsR7WBMs2YWuHf2A3JVrhpr99CxRQZDVWvCDpetw9xqEvLKoViTNVKyfeN823KE26uHmRv52geyUJDnpWDCjoezFxQVWl4ODWNag8Wtw74Rx44nyl4pw",
    PRODUCTION:
      "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjIwLCJraWQiOiI2NzM5MWEyMWVlMDU0NzJhYjEzM2NkNzA4ZWM4MDQ4ZiJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9zaWQiOiIwMDAwMDAwMC0wMDAwLTAwMDAtMDAwMC0wMDAwMDAwMDAwMDAiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL2dyb3Vwc2lkIjoiYTAxZmQ4YzEtZGNkYS00NzNiLTg1Y2ItZWNhNzA5OGY1YjY5Iiwic2NvcGUiOiJmdWxsYWNjZXNzIiwidGVuYW50X2dyb3VwX2lkIjoiOWM3ZDk3NjYtOWViZi00N2E0LTk0ZTYtM2YxZjUwY2Q0YjJmIiwibmJmIjoxNzI4NjM4MjU2LCJleHAiOjIwNDQyMTQyNTYsImlzcyI6IkxlZ2FsU2ltcGxpIiwiYXVkIjoiUERGU2ltcGxpIn0.f-EANyK8sM4V9keqN54Y7qZmVgkj7I_yG7N-VaFa8CsQWPYBTNe39Tj0tYAInch84TlBMGIPLUV0CRworzDvG9l8eS0XkEJ5tqCQpXFuO62ahOj814LmsdOzLn8Euw2jyy0pVrLT2mpv-FlRzK6n1SeqY-uhftp9SSkWHQ91QJI9VLUZE3_sOpf73A1-4RUPneekOEFyfLkouMjEkkcvScnkX5IsjG9VD3N-7dZSOd_gnBGSaFOKNWyFu6A2uoYP3eyK86b9wMKifhszATyWXI2ltD9eTtq9GRt48oEePIRmS0Q8l5j39h1rA_-4W7lbN1YajyYprKG3cEUlHTXwCA",
    STAGING:
      "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjIwLCJraWQiOiI2NzM5MWEyMWVlMDU0NzJhYjEzM2NkNzA4ZWM4MDQ4ZiJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9zaWQiOiIwMDAwMDAwMC0wMDAwLTAwMDAtMDAwMC0wMDAwMDAwMDAwMDAiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL2dyb3Vwc2lkIjoiYTAxZmQ4YzEtZGNkYS00NzNiLTg1Y2ItZWNhNzA5OGY1YjY5Iiwic2NvcGUiOiJmdWxsYWNjZXNzIiwidGVuYW50X2dyb3VwX2lkIjoiOWM3ZDk3NjYtOWViZi00N2E0LTk0ZTYtM2YxZjUwY2Q0YjJmIiwibmJmIjoxNzI4NjM4MjU2LCJleHAiOjIwNDQyMTQyNTYsImlzcyI6IkxlZ2FsU2ltcGxpIiwiYXVkIjoiUERGU2ltcGxpIn0.f-EANyK8sM4V9keqN54Y7qZmVgkj7I_yG7N-VaFa8CsQWPYBTNe39Tj0tYAInch84TlBMGIPLUV0CRworzDvG9l8eS0XkEJ5tqCQpXFuO62ahOj814LmsdOzLn8Euw2jyy0pVrLT2mpv-FlRzK6n1SeqY-uhftp9SSkWHQ91QJI9VLUZE3_sOpf73A1-4RUPneekOEFyfLkouMjEkkcvScnkX5IsjG9VD3N-7dZSOd_gnBGSaFOKNWyFu6A2uoYP3eyK86b9wMKifhszATyWXI2ltD9eTtq9GRt48oEePIRmS0Q8l5j39h1rA_-4W7lbN1YajyYprKG3cEUlHTXwCA",
    DEVELOPMENT:
      "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjIwLCJraWQiOiI0NGUwZmY2MzgwY2E0YzhkOWFlNzBjMjExMjc5NGFiNyJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9zaWQiOiIwMDAwMDAwMC0wMDAwLTAwMDAtMDAwMC0wMDAwMDAwMDAwMDAiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL2dyb3Vwc2lkIjoiN2ZjOWY0MjUtMTQ2My00YThlLTg1NTYtNmM2YjM0Y2ZjZmY2Iiwic2NvcGUiOiJmdWxsYWNjZXNzIiwidGVuYW50X2dyb3VwX2lkIjoiNTgwYzhiNWEtZGI4My00ODM0LTE0ZWYtMDhkOTUwMWU3MzVkIiwibmJmIjoxNzI4NTUzMDk2LCJleHAiOjIwNDQxMjkwOTYsImlzcyI6IkxlZ2FsU2ltcGxpIiwiYXVkIjoiUERGU2ltcGxpIn0.KameEF9JU4__i_tmeiJQprFIpc0gGoNrXE4ti-ZqCqAhT2UflZL6NCz-herJ3pZfRTGUfsvR8n5-kPZeALbv1F_JY3sjEN4k5m-D2r4L2XjnpS7nNTznc2K5SImmounTp5F3kscXTz-qdQMInE3FjDD6U0Dbl8VPCFQR9e1XzS3_cegwTa3-tqcM7bJAsGkC17EQMec-loQiv55FISd_L8_Wq2dt3QbCnEYsR7WBMs2YWuHf2A3JVrhpr99CxRQZDVWvCDpetw9xqEvLKoViTNVKyfeN823KE26uHmRv52geyUJDnpWDCjoezFxQVWl4ODWNag8Wtw74Rx44nyl4pw",
  };
  return jwtToken[currentEnv];
};

export const addSignatureTextFile = async () => {
  try {
    let signatureKey = !!readCookie("visitorGuid") ? readCookie("visitorGuid") : null;
    let res = await docEditorServiceApi.ReplaceSignature(signatureKey);
    console.log("res", res);
  } catch (error) {
    console.error("Error getting save signature response:", error);
    return null;
  }
};
export const arrayBufferToBase64 = (buffer) => {
  let binary = "";
  for (let i = 0; i < buffer.length; i++) {
    binary += String.fromCharCode(buffer[i]);
  }
  return btoa(binary);
};
export const getAuthHeader = () => {
  let token = readCookie("jwtToken");
  const jwtToken = token ? token : getServiceToken();
  const headers = { Authorization: "Bearer" + " " + jwtToken };
  return headers;
};

export const checkQueryParams = (qparams) => {
  let haveAllQparams =
    (!!qparams && window.location.search !== "" && qparams?.has("ofn")) ||
    qparams?.has("evp") ||
    qparams?.has("gusr") ||
    qparams?.has("querydata");
  return haveAllQparams;
};
export function checkIP(ipAddress) {
  const ipv4Regex =
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){2}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

  const ipv6Regex =
    /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|(::1)|(([0-9a-fA-F]{1,4}:){1,6}:)|(:{2}[0-9a-fA-F]{1,4}))$/;

  const isIPv4 = ipv4Regex.test(ipAddress);
  const isIPv6 = ipv6Regex.test(ipAddress);
  const isValid = isIPv4 || isIPv6;

  let isPrivate = false;
  let isLoopback = false;

  if (isIPv4) {
    const parts = ipAddress.split(".").map(Number);
    if (
      parts[0] === 10 ||
      (parts[0] === 172 && parts[1] >= 16 && parts[1] <= 31) ||
      (parts[0] === 192 && parts[1] === 168)
    ) {
      isPrivate = true;
    }
    if (parts[0] === 127) {
      isLoopback = true;
    }
  }

  if (isIPv6) {
    // ::1 is loopback
    if (ipAddress === "::1") {
      isLoopback = true;
    }
    // fc00::/7 is private (unique local address)
    if (/^fc|^fd/i.test(ipAddress)) {
      isPrivate = true;
    }
  }

  return {
    ip: ipAddress,
    isValid,
    isIPv4,
    isIPv6,
    isPrivate,
    isPublic: isValid && !isPrivate,
    isLoopback,
  };
}
//Note: Created this function because raygun was not working from raygun4js package
export const sendRaygunError = async (message, customData = {}) => {
  const payload = {
    occurredOn: new Date().toISOString(),
    details: {
      machineName: window.location.hostname,
      version: "1.0.0",
      client: {
        name: "CustomClient",
        version: "1.0",
      },
      error: {
        className: "ManualError",
        message,
        stackTrace: [],
      },
      environment: {
        osVersion: navigator.platform,
        cpu: navigator.hardwareConcurrency?.toString(),
        architecture: navigator.userAgent,
      },
      userCustomData: customData,
    },
  };

  try {
    await fetch("https://api.raygun.io/entries", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-ApiKey": process.env.REACT_APP_RAYGUN_API_KEY,
      },
      body: JSON.stringify(payload),
    });
  } catch (err) {
    console.error("Failed to send error to Raygun:", err);
  }
};

export const classNames = (...classes) => {
  return classes.filter(Boolean).join(" ");
};

export const createEmailData = (toEmails, fromEmail, firstName, lastName, subject, message) => {
  let createEmailDataRequest = {
    ToEmails: [
      {
        Email: toEmails,
        FirstName: firstName,
        LastName: lastName,
      },
    ],
    CcEmails: null,
    BCcEmails: null,
    FromEmail: {
      Email: fromEmail,
      FirstName: firstName,
      LastName: lastName,
    },
    Subject: subject,
    Message: message,
  };
  return createEmailDataRequest;
};

export const createEmailShareDocument = (docId, itemType, requestedType, fileType) => {
  let createEmailShareDocumentRequest = {
    DocId: docId,
    FileType: fileType,
    RequestedType: requestedType,
    ItemType: itemType,
  };
  return createEmailShareDocumentRequest;
};
export const createEmailShareRequest = (
  userId,
  documents,
  emailData,
  shareAsLink,
  locale,
  portalCD,
  is24HourDelayed,
  sharedDocumentName,
) => {
  let createEmailShareRequest = {
    UserId: userId,
    Documents: [documents],
    EmailData: emailData,
    ShareAsLink: shareAsLink,
    Locale: locale,
    PortalCD: portalCD,
    Is24HourDelayed: is24HourDelayed,
    b2BRequest: {},
  };
  return createEmailShareRequest;
};

export function isPricingPageFlow() {
  const rawCookie = readCookie("p_scsgccd");
  if (!rawCookie) return false;

  const decodedCookie = decodeURIComponent(rawCookie);
  const details = decodedCookie.split("|");
  const isPricing = details.length >= 3;
  return isPricing;
}
export function buildPricingPageUrl() {
  const rawCookie = readCookie("p_scsgccd");
  const users = readCookie("p_users");

  if (!rawCookie) return "";

  const [skuc, skuid, currency] = decodeURIComponent(rawCookie).split("|");

  const queryParams = new URLSearchParams({
    skuid,
    skuc,
    currency,
  });

  if (users) {
    queryParams.append("users", users);
  }
  const queryString = `billing?${queryParams}`;
  deleteCookie("p_scsgccd");
  deleteCookie("p_users");
  return queryString;
}
function getPortalConfig() {
  const domain = currentDomain();
  if (readCookie("vs_prtlSrc") === "PSSC") {
    return {
      portalBaseUrl: getPdfSimpliBaseURL,
      senderNamePrefix: "Secure",
      portal: "SecureSimpli",
    };
  }

  switch (domain) {
    case DomainEnum.SIGNSIMPLI:
      return {
        portalBaseUrl: getSignSimpliBaseURL,
        senderNamePrefix: "Sign",
        portal: "SignSimpli",
      };
    case DomainEnum.WORKSIMPLI:
      return {
        portalBaseUrl: getWorksimpliEndPoint,
        senderNamePrefix: "Work",
        portal: "WorkSimpli",
      };
    case DomainEnum.LEGALSIMPLI:
      return {
        portalBaseUrl: getLegalSimpliBaseURL,
        senderNamePrefix: "Legal",
        portal: "LegalSimpli",
      };
    default:
      return {
        portalBaseUrl: getPdfSimpliBaseURL,
        senderNamePrefix: "Pdf",
        portal: "PDFSimpli",
      };
  }
}

export const getQueryParam = (param) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};
export const isLinkValid = () => {
  const ts = getQueryParam("ts");
  if (!ts) return false;
  const linkTimestamp = parseInt(ts, 10) * 1000; // convert seconds to ms
  const now = Date.now();
  const threeDays = 3 * 24 * 60 * 60 * 1000;
  return now - linkTimestamp <= threeDays;
};

export const isOfferPlan = () => ["1", "10"].includes(readCookie("opt"));
export const getContentType = (ext) => {
  var contenttype = "";
  switch (ext) {
    case "doc":
      contenttype = "application/vnd.ms-word";
      break;
    case "docx":
      contenttype = "application/vnd.ms-word";
      break;
    case "xls":
      contenttype = "application/vnd.ms-excel";
      break;
    case "xlsx":
      contenttype = "application/vnd.ms-excel";
      break;
    case "jpg":
      contenttype = "image/jpg";
      break;
    case "jpeg":
      contenttype = "image/jpeg";
      break;
    case "png":
      contenttype = "image/png";
      break;
    case "gif":
      contenttype = "image/gif";
      break;
    case "pdf":
      contenttype = "application/pdf";
      break;
    case "tiff":
      contenttype = "image/tiff";
      break;
    case "tif":
      contenttype = "image/tif";
      break;
    case "zip":
      contenttype = "application/zip";
      break;
    case "odt":
      contenttype = "application/vnd.oasis.opendocument.text";
      break;
    case "pptx":
    case "ppt":
      contenttype = "application/vnd.ms-powerpoint";
      break;
  }
  return contenttype;
};
export const toLowercaseExtension = (filename) => {
  const parts = filename.split(".");

  // Check if there's an extension
  if (parts.length > 1) {
    const name = parts.slice(0, -1).join(".");
    const extension = parts[parts.length - 1].toLowerCase();

    // Return the name with the lowercase extension
    return `${name}.${extension}`;
  }

  // If there's no extension, return the original filename
  return filename;
};
export const getCategoryName = (ext) => {
  let categoryName = "";
  if (AudioExtension.includes(ext.toUpperCase())) {
    categoryName = "audio";
  } else if (VideoExtension.includes(ext.toUpperCase())) {
    categoryName = "video";
  } else if (ImageExtension.includes(ext.toUpperCase())) {
    categoryName = "image";
  }
  return categoryName;
};

export const changeCommonlyUsedExt = (ext) => {
  var changedExt = ext;
  if (ext == "tif") {
    changedExt = "tiff";
  }
  if (ext == "jpeg") {
    changedExt = "jpg";
  }
  if (ext == "xlsx") {
    changedExt = "xls";
  }
  if (ext == "docx") {
    changedExt = "doc";
  }
  if (ext == "pptx") {
    changedExt = "ppt";
  }
  return changedExt;
};
export const replaceFileExtension = (fileName, newExtension) => {
  const lastPeriodIndex = fileName.lastIndexOf(".");
  if (lastPeriodIndex >= 0) {
    const nameWithoutExtension = fileName.substring(0, lastPeriodIndex);
    return `${nameWithoutExtension}.${newExtension}`;
  }
  return `${fileName}.${newExtension}`;
};
export const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    return "mobile";
  }
  return "desktop";
};

export const createMagicLink = (popupType, locale = "") => {
  let legacyToken = readCookie("legacyTicket");
  let jwtToken = readCookie("jwtToken");
  const localelan = locale && locale !== "en" ? locale : "";

  let url = getPdfSimpliBaseURL + "account/sso-transfer";

  let tgtUrl = `${getPdfSimpliBaseURL.replace(/\/$/, "")}${ROUTE_CONSTANT.DASHBOARD_TRANSFER_LOCALE.replace(
    /\/$/,
    "",
  )}?pt=${popupType}`;

  if (tgtUrl) {
    tgtUrl = tgtUrl.replace(":locale", localelan);
    tgtUrl = tgtUrl.replace(/(?<!:)(\/{2,})/g, "/");
  }

  const params = {
    lgct: encodeURIComponent(legacyToken),
    tgt: encodeURIComponent(tgtUrl),
  };

  params["jtkn"] = jwtToken;

  const queryString = Object.entries(params)
    .map(([key, val]) => `${key}=${val}`)
    .join("&");
  return `${url}?${queryString}`;
};

export const normalizeGuid = (value) => {
  if (!value) return "";

  const GUID_WITH_HYPHENS = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

  const GUID_WITHOUT_HYPHENS = /^[0-9a-fA-F]{32}$/;

  if (GUID_WITH_HYPHENS.test(value)) {
    return value.toLowerCase();
  }

  if (GUID_WITHOUT_HYPHENS.test(value)) {
    return value.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, "$1-$2-$3-$4-$5").toLowerCase();
  }

  return "";
};

export const handleAbTestDashboardFunnel = async () => {
  if (readCookie(DASHBOARD_ABTESTID_COOKIE)) {
    return;
  }
  let userGuid = isUserLoggedIn() && readCookie("userguid") ? readCookie("userguid") : "";
  const normalizedUserGuid = normalizeGuid(userGuid);
  const isUser = normalizedUserGuid !== "";

  const data = {
    AbTestId: DASHBOARD_ABTESTID,
    userGuid: isUser ? normalizedUserGuid : EMPTY_GUID,
    visitorID: !!readCookie("visitorGuid") ? readCookie("visitorGuid") : "",
    portalCD: "PS",
  };

  let response = null;

  if (isUser) {
    response = await UserGuidABTestConduct(data);
  }

  if (!response || response?.abTestVariant === 0) {
    return;
  }

  createCookie(DASHBOARD_ABTESTID_COOKIE, response?.abTestVariant?.toString(), 1);
};
export const createRedirectionLink = (baseUrl, locale = "") => {
  const cleanedBaseUrl = baseUrl.replace(/\/$/, "");
  const localelan = locale && locale !== "en" ? locale : "";

  const signinPath = "/app"+localelan+"/account/signin";
  const targetPath = "/app"+localelan+"/dashboard/settings#users-team-settings";

  return `${cleanedBaseUrl}${signinPath}?tgt=${cleanedBaseUrl}${targetPath}`;
};
export const clearIndexedDB = async () => {
  try {
    await new Promise((resolve, reject) => {
      const request = indexedDB.deleteDatabase("MyFileDB");

      request.onsuccess = () => {
        console.log("IndexedDB cleared");
        resolve();
      };

      request.onerror = () => {
        reject("Error clearing DB");
      };

      request.onblocked = () => {
        console.warn("DB delete blocked");
      };
    });

    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

